export default {
  title: 'Cargo Type Management',

  // Search filter area
  search: {
    keyword: 'Keyword',
    keywordPlaceholder: 'Code, Chinese name, English name',
    status: 'Status',
    statusPlaceholder: 'Select status',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    add: 'Add Cargo Type',
    edit: 'Edit',
    delete: 'Delete',
    enableItem: 'Enable',
    disableItem: 'Disable',
    recordsCount: '{count} records in total'
  },

  // Table columns
  table: {
    code: 'Code',
    nameCn: 'Chinese Name',
    nameEn: 'English Name',
    sortOrder: 'Sort',
    source: 'Source',
    status: 'Status',
    remark: 'Remark',
    operation: 'Actions'
  },

  // Data source
  source: {
    platform: 'Platform',
    tenant: 'Tenant'
  },

  // Status text
  statusText: {
    enabled: 'Enabled',
    disabled: 'Disabled'
  },

  // Modal
  modal: {
    addTitle: 'Add Cargo Type',
    editTitle: 'Edit Cargo Type'
  },

  // Form
  form: {
    code: 'Code',
    codePlaceholder: 'Enter code, e.g. FURNITURE',
    nameCn: 'Chinese Name',
    nameCnPlaceholder: 'Enter Chinese name',
    nameEn: 'English Name',
    nameEnPlaceholder: 'Enter English name (optional)',
    sortOrder: 'Sort Order',
    status: 'Status',
    remark: 'Remark',
    remarkPlaceholder: 'Enter remark (optional)'
  },

  // Validation
  validation: {
    codeRequired: 'Please enter code',
    nameCnRequired: 'Please enter Chinese name'
  },

  // Confirm
  confirm: {
    toggleStatus: 'Are you sure to {action} this cargo type?',
    delete: 'Are you sure to delete this cargo type?'
  },

  // Messages
  messages: {
    loadError: 'Failed to load data',
    createSuccess: 'Created successfully',
    updateSuccess: 'Updated successfully',
    saveError: 'Save failed',
    deleteSuccess: 'Deleted successfully',
    deleteError: 'Delete failed',
    statusToggleSuccess: 'Status changed successfully',
    statusToggleError: 'Operation failed'
  }
}
